<template>
  <div>
    <div
      v-if="id > 0"
      ref="executionListOuter"
      id="executions-outer"
      class="pd-10 overflow-auto"
      :style="`height: ${scrHeight.execution}px`"
    >
      <execution-list
        ref="executionList"
        :taskId="id"
        @on-reach-bottom="onReachBottom"
        @on-attach="showFile"
      ></execution-list>
    </div>
    <execution-reply
      v-if="id > 0"
      ref="executionReply"
      @on-height="
        scrHeight.executionReply = $event;
        getWindowHeight();
      "
      :taskId="id"
      @on-posted="executionInit"
      class="bd-t"
    ></execution-reply>
  </div>
</template>
<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
var $ = window.$;
export default {
  components: {
    executionList: () => ({
      component: import("@/components/task/components/executions/list.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    executionReply: () => ({
      component: import("@/components/task/components/executions/reply.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    id: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      scrHeight: {
        execution: 600,
        executionReply: 150
      }
    };
  },
  methods: {
    executionInit(e) {
      this.$refs.executionList.initById(e);
    },
    onReachBottom(e) {
      var container = this.$el.querySelector("#executions-outer");
      $("#executions-outer").animate({
        scrollTop: e == "bottom" ? container.scrollHeight : 0
      });
    },
    getWindowHeight() {
      let extraSide = this.scrHeight.executionReply + 150;
      this.scrHeight.execution = window.innerHeight - extraSide;
    },
    showFile(e) {
      //console.log(e);
      this.$emit("on-attach", e);
      //console.log(e);
    }
  }
};
</script>
